import { render, staticRenderFns } from "./WDMaturingStatusBadge.vue?vue&type=template&id=dead26ae&"
import script from "./WDMaturingStatusBadge.vue?vue&type=script&lang=js&"
export * from "./WDMaturingStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports